import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledTagGroupPieChart = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  
  .TagGroupPieChart {
    &-chart {
      height: 100%;
      overflow: hidden;
    }
    
    &-chart-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      height: 100%;
      aspect-ratio: 1;
    }

    &-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;

      .totalCount {
        font-size: ${props => props.theme.fontSize(40)};
        line-height: ${props => props.theme.lineHeight('1.125f')};
        font-weight: 700;
      }

      .H6 {
        text-align: center;
      }
    }
    
    &-legend {
      flex-grow: 1;
      align-items: flex-end;
      min-height: ${props => props.theme.layout(48)};
    }
  }

  // variants
  &.TagGroupPieChart-half {
    .TagGroupPieChart {
      &-center {
        height: 100%;
        justify-content: end;

        .Icon {
          font-size: ${props => props.theme.fontSize(24)};
        }

        .totalCount {
          margin-top: ${props => props.theme.layout(4)};
          margin-bottom: ${props => props.theme.layout(-3)};
          font-size: ${props => props.theme.fontSize(20)};
          line-height: ${props => props.theme.lineHeight('1f')};
          font-weight: 400;
        }

        .title {
          display: none;
        }
      }
    }
  }

  &.TagGroupPieChart-showActiveShape {
    .TagGroupPieChart {
      &-center {
        margin: 32%;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledTagGroupPieChart.propTypes = {
  theme: PropTypes.object
};

export default StyledTagGroupPieChart;
